// import Swiper from "swiper";
// import { Navigation, Pagination, A11y } from 'swiper/modules';

const swiperCarousel = (function($) {
    return {

        swiperInstance: null,

        // Initial function
        init: function() {

            let domEls = document.querySelectorAll('.js-swiper-carousel');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    swiperCarousel.swiperInstance = new Swiper(el, params);
                })
            }
        }
    };
})(jQuery);

const getSwiperParams = () => {
    return {
        // modules: [Navigation, Pagination, A11y],
        watchOverflow: true,
        centeredSlides: true,
        speed: 750,
        spaceBetween: 72,
        slidesPerView: 1,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }
}

//Document on load
jQuery(document).ready(function($) {
    swiperCarousel.init();
});
